import { Job } from '~/jobiqo/types/types';

/**
 * Gets the logo for the job.
 */
export const getTeaserImage = (job: Job) => {
  if (job?.logo?.url) {
    return job.logo.url;
  } else {
    if (job?.organizationProfile?.logo?.url) {
      return job.organizationProfile?.logo?.url;
    }
  }
  return null;
};
